import React, { useState } from 'react'

import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'

import _ from 'lodash'
import { Button } from 'ziphy-web-shared/basic/lib/buttons'
import { Modal, ModalToolbarBtn } from 'ziphy-web-shared/basic/lib/utilities/modals'

import { $booking } from '@store'

import VoucherSelector from '../../../library/voucherSelector/VoucherSelector'
import styles from './VoucherSelect.modal.module.scss'

const VoucherSelectModal = ({ _core }) => {
  const { t } = useTranslation()
  const [voucher, setVoucher] = useState(null)

  const handleSubmit = () => {
    $booking.patients.updateAllSelected(() => ({ voucher: voucher }))
    _core.onHide()
  }

  return (
    <Modal centered _core={_core}>
      <div className="modal-toolbar">
        <ModalToolbarBtn type="close" action={_core.onHide} />
      </div>
      <Modal.Header>{t('book_details.label.add_voucher')}</Modal.Header>
      <Modal.Body>
        <VoucherSelector
          selected={voucher}
          onChangeSelected={setVoucher}
          availablePracticeIds={$booking.availablePracticeIds}
          practiceServiceId={$booking.practiceService.id}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          mode={['primary']}
          className={styles.submitButton}
          disabled={_.isEmpty(voucher)}
          onClick={handleSubmit}
        >
          {t('btn.submit')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default observer(VoucherSelectModal)
